"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var native_1 = __importDefault(require("styled-components/native"));
var ATLAtomLabel_1 = require("../atoms/ATLAtomLabel");
var ThemeProvider_1 = require("../theme/ThemeProvider");
var ATLAtomButtonToggle_1 = require("../atoms/ATLAtomButtonToggle");
var react_native_1 = require("react-native");
var TextAlignmentEnum_1 = require("../enums/TextAlignmentEnum");
var defaultProps = {
    complementary: false,
    buttonToggleBaseProps: {},
    linkLabelBaseProps: {},
    regularLabelBaseProps: {}
};
// ASSETS --------------------------------------------------------------------------------------------------------------
var activeImageDefault = require('../assets/checkBox.png');
var inactiveImageDefault = require('../assets/checkBoxBlank.png');
// STYLED COMPONENTS ---------------------------------------------------------------------------------------------------
exports.CheckboxWrapper = native_1.default(react_native_1.View)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  flex-direction: row;\n\tpadding:  ", "px\n\t          ", "px;\n"], ["\n  flex-direction: row;\n\tpadding:  ", "px\n\t          ", "px;\n"])), function (_a) {
    var atlTheme = _a.theme, props = __rest(_a, ["theme"]);
    return props.verticalMargin || atlTheme.SpacingBase;
}, function (_a) {
    var atlTheme = _a.theme, props = __rest(_a, ["theme"]);
    return props.horizontalMargin || atlTheme.SpacingInputMarginHorizontal;
});
exports.TextWrapper = native_1.default(react_native_1.View)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  flex: 1;\n\tmargin: 0 0 0 ", "px;\n"], ["\n  flex: 1;\n\tmargin: 0 0 0 ", "px;\n"
    // COMPONENT -----------------------------------------------------------------------------------------------------------
])), function (_a) {
    var atlTheme = _a.theme, props = __rest(_a, ["theme"]);
    return props.horizontalPadding || atlTheme.SpacingMarginal;
});
// COMPONENT -----------------------------------------------------------------------------------------------------------
exports.ATLCheckbox = function (_a) {
    var value = _a.value, onChange = _a.onChange, texts = _a.texts, complementary = _a.complementary, horizontalMargin = _a.horizontalMargin, horizontalPadding = _a.horizontalPadding, verticalMargin = _a.verticalMargin, buttonToggleBaseProps = _a.buttonToggleBaseProps, linkLabelBaseProps = _a.linkLabelBaseProps, regularLabelBaseProps = _a.regularLabelBaseProps;
    var theme = ThemeProvider_1.useTheme();
    // Renders text when it is a link
    var renderLink = function (linkText, onPressLink) { return (react_1.default.createElement(ATLAtomLabel_1.ATLAtomLabel, __assign({ key: linkText, onPress: onPressLink, fontFamily: theme.FontFamilySystem, fontSize: theme.FontSizeButton, fontWeight: theme.FontWeightStrong, lineHeight: theme.LineHeightBase, textAlign: TextAlignmentEnum_1.TextAlignmentEnum.left, textCase: theme.TextCaseButton, textColor: complementary ? theme.ColorComplementary1 : theme.ColorBrand1Default }, linkLabelBaseProps), linkText)); };
    // Renders text when it is not a link
    var renderRegularText = function (regularText) { return (react_1.default.createElement(ATLAtomLabel_1.ATLAtomLabel, __assign({ key: regularText, fontFamily: theme.FontFamilySystem, fontSize: theme.FontSizeBody, fontWeight: theme.FontWeightNormal, lineHeight: theme.LineHeightBase, textAlign: TextAlignmentEnum_1.TextAlignmentEnum.left, textColor: complementary ? theme.ColorComplementary1 : theme.ColorHighContrast }, regularLabelBaseProps), regularText)); };
    // Renders checkbox buttonToggle
    var renderCheckboxButton = function () { return (react_1.default.createElement(ATLAtomButtonToggle_1.ATLAtomButtonToggle, __assign({ value: value, onChange: onChange, activeImage: activeImageDefault, inactiveImage: inactiveImageDefault, size: 24, tintColor: complementary ? theme.ColorComplementary1 : theme.ColorBrand1Default }, buttonToggleBaseProps))); };
    // Renders all text together, both link and regular, in the order they have been assigned
    var renderAllText = function (checkboxTexts) { return (checkboxTexts.map(function (t) {
        if (t.onPress) {
            return (renderLink(t.text, t.onPress));
        }
        else {
            return (renderRegularText(t.text));
        }
    })); };
    // Returns complete ATLCheckbox
    return (react_1.default.createElement(react_native_1.TouchableWithoutFeedback, { onPress: onChange },
        react_1.default.createElement(exports.CheckboxWrapper, { horizontalMargin: horizontalMargin, verticalMargin: verticalMargin },
            renderCheckboxButton(),
            react_1.default.createElement(exports.TextWrapper, { horizontalPadding: horizontalPadding },
                react_1.default.createElement(react_native_1.Text, null, texts && renderAllText(texts))))));
};
exports.ATLCheckbox.defaultProps = defaultProps;
exports.ATLCheckbox.displayName = 'ATLCheckbox';
var templateObject_1, templateObject_2;
